import React from "react";

export default function LandscapeCards() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-6 py-20 font-[Poppins]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap');

        @keyframes show-data {
          50% { transform: translateY(-10rem); }
          100% { transform: translateY(-7rem); }
        }

        @keyframes remove-data {
          0% { transform: translateY(-7rem); }
          50% { transform: translateY(-10rem); }
          100% { transform: translateY(0.5rem); }
        }

        .card-article {
          position: relative;
          overflow: hidden;
        }

        .card-data {
          position: absolute;
          left: 0;
          right: 0;
          margin-inline: auto;
          bottom: -9rem;
          opacity: 0;
          transition: opacity 1s 1s;
        }

        .card-article:hover .card-data {
          animation: show-data 1s forwards;
          opacity: 1;
          transition: opacity .3s;
        }

        .card-article:not(:hover) .card-data {
          animation: remove-data 1s forwards;
        }

        @media (max-width: 768px) {
          .card-article {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .card-data {
            position: static !important;
            opacity: 1 !important;
            animation: none !important;
            transform: none !important;
            margin-inline: 0 !important;
            bottom: 0 !important;
            width: 100% !important;
            max-width: 328px !important;
            margin-top: 0.5rem !important;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.10) !important;
            border-radius: 1rem !important;
            padding: 1.2rem 1rem 1rem 1rem !important;
          }
        }
          @media (max-width: 768px) {
            @keyframes cardFadeUp {
              0% { opacity: 0; transform: translateY(40px); }
              100% { opacity: 1; transform: translateY(0); }
            }
            .card-article {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .card-data {
              position: static !important;
              opacity: 1 !important;
              animation: cardFadeUp 0.8s cubic-bezier(0.22, 1, 0.36, 1) both !important;
              transform: none !important;
              margin-inline: 0 !important;
              bottom: 0 !important;
              width: 100% !important;
              max-width: 328px !important;
              margin-top: 0.5rem !important;
              box-shadow: 0 2px 12px 0 rgba(0,0,0,0.10) !important;
              border-radius: 1rem !important;
              padding: 1.2rem 1rem 1rem 1rem !important;
              z-index: 2;
            }
          }
      `}</style>

      <div className="grid gap-14 md:grid-cols-2 xl:grid-cols-3">
        {[
          {
            img: "images/landscape-1.png",
            desc: "Director",
            title: "Mr.Nandkumar Jorwekar",
          },
          {
            img: "images/landscape-2.png",
            desc: "Director",
            title: "Mr.Chetan Kondhalkar",
          },
          {
            img: "images/landscape-3.png",
            desc: "Director",
            title: "Mr.Rahul Pawar",
          },
        ].map((card, index) => (
          <article key={index} className="card-article">
            <img
              src={card.img}
              alt={card.title}
              className="w-[328px] xl:w-[348px] rounded-2xl block"
            />

            <div className="card-data w-[280px] xl:w-[316px] bg-white p-6 xl:px-10 shadow-xl rounded-xl">
              <span className="block text-sm text-gray-600 mb-1">
                {card.desc}
              </span>
              <h2 className="text-xl xl:text-2xl font-medium text-gray-900 mb-3">
                {card.title}
              </h2>
              {/* Read More removed */}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
